import styled from '@emotion/styled';

export const FloorRangeWrapper = styled.section`
  & > section > *:last-child { {
    overflow: visible;
    border-bottom-width: 0;
  }
`;
